
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bCOr0", function(module, exports) {
/* ArchiveDialogBaseComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $xQxzY = parcelRequire("xQxzY");


var $7541v = parcelRequire("7541v");


var $inPa6 = parcelRequire("inPa6");


var $hArLp = parcelRequire("hArLp");


var $eEA8O = parcelRequire("eEA8O");

var $9YwaJ = parcelRequire("9YwaJ");


var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $6mKj3 = parcelRequire("6mKj3");


var $e9zUf = parcelRequire("e9zUf");

var $1UApO = parcelRequire("1UApO");


var $cLo2u = parcelRequire("cLo2u");


var $fTMXN = parcelRequire("fTMXN");


var $b3j2Y = parcelRequire("b3j2Y");


var $1kHsc = parcelRequire("1kHsc");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $lsxnT = parcelRequire("lsxnT");


var $61vzn = parcelRequire("61vzn");


var $12UWa = parcelRequire("12UWa");


var $jjVGE = parcelRequire("jjVGE");


var $aqBZ0 = parcelRequire("aqBZ0");

const $9893d5f9cd612858$export$6f85644dafe908c8 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bahesu3 _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $9893d5f9cd612858$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    cancelButtonText: {
        id: "archive-pages.archive.dialog.button.cancel",
        defaultMessage: "Cancel"
    },
    ARCHIVE_withoutNestedPagesTitle: {
        id: "archive-pages.without-nested-pages.archive.dialog.title",
        defaultMessage: "This is a parent item to other content items"
    },
    ARCHIVE_singlePageWithNoteV2: {
        id: "archive-pages.single.archive.dialog.title.v2",
        defaultMessage: "Archive item"
    },
    ARCHIVE_nestedPagesButtonText: {
        id: "archive-pages.archive-nested-pages.dialog.button.archive",
        defaultMessage: "Archive"
    },
    ARCHIVE_archiveAnywayButtonText: {
        id: "archive-pages.archive.dialog.button.archive",
        defaultMessage: "Archive anyway"
    },
    ARCHIVE_singleArchiveButtonText: {
        id: "archive-pages.archive.single.dialog.button.archive",
        defaultMessage: "Archive"
    },
    ARCHIVE_NextButtonText: {
        id: "archive-pages.archive.single.dialog.button.next",
        defaultMessage: "Next"
    },
    ARCHIVE_archiveParentButtonSelectionLimitReachedText: {
        id: "archive-pages.archive-nested-pages.dialog.selection-limit-reached.button.archive",
        defaultMessage: "Archive parent"
    },
    ARCHIVE_nestedPagesTitleGeneric: {
        id: "archive-pages.nested-pages.archive.dialog.title.generic.M2",
        defaultMessage: "Archive parent item"
    },
    UNARCHIVE_pageDialogTitle: {
        id: "archive-pages.single-page.unarchive.dialog.title",
        defaultMessage: "Choose destination"
    },
    UNARCHIVE_buttonText: {
        id: "archive-pages.single-page.unarchive.dialog.button.unarchive",
        defaultMessage: "Restore"
    },
    UNARCHIVE_restoreParentButtonSelectionLimitReachedText: {
        id: "archive-pages.archive-nested-pages.dialog.selection-limit-reached.button.unarchive",
        defaultMessage: "Restore parent"
    }
});
const $9893d5f9cd612858$var$buttonSubjectIdPrefix = (isArchive)=>isArchive ? 'archiveNestedPage' : 'restorePageDestination';
const $9893d5f9cd612858$export$e020ae5d4bb1aae5 = ({ getAdditionalMutationVariables: // ArchiveDialogInnerProps:
getAdditionalMutationVariables, getAdditionalAnalyticsAttributes: getAdditionalAnalyticsAttributes, children: children, descriptionText: descriptionText, appearance: appearance, width: width = 520, allowNestedPages: allowNestedPages, includeNestedPages: includeNestedPages, isSingleArchive: isSingleArchive, isSelectionLimitReached: isOverSelectionLimit = false, isSubmitDisabled: isSubmitDisabled = false, contentId: // ArchiveDialogPropsWithContentId:
contentId, analyticsSource: analyticsSource, isArchive: isArchive, startMutationCallback: startMutationCallback, shouldUseAutomationDiscovery: shouldUseAutomationDiscovery = false, archivingError: archivingError, isArchiveInProgress: isArchiveInProgress, setIsNestedActionsDialogNotePageEnabled: setIsNestedActionsDialogNotePageEnabled, isNestedActionsDialogNotePageEnabled: isNestedActionsDialogNotePageEnabled })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(true);
    const [isPageMutationStarted, setIsPageMutationStarted] = (0, $42omo.useState)(false);
    const [isAutomationDiscoveryMessageVisible, setIsAutomationDiscoveryMessageVisible] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const hasUserSeenAutomationDiscoveryMessage = (0, $e9zUf.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_ARCHIVE_FROM_OVERFLOW_MENU);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const previousIsArchiveInProgress = (0, $7541v.default)(isArchiveInProgress);
    (0, $42omo.useEffect)(()=>{
        if (previousIsArchiveInProgress === true && !isArchiveInProgress) setIsPageMutationStarted(false);
        if (archivingError) setIsOpen(false);
    }, [
        isArchiveInProgress,
        archivingError,
        previousIsArchiveInProgress
    ]);
    const { data: spaceAdminData, error: checkSpaceAdminError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query ArchiveDialogBaseComponentCheckSpaceAdminQuery($spaceKey:String){space(key:$spaceKey){id currentUser{isAdmin}}}`, {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey || edition !== (0, $euL71.ConfluenceEdition).PREMIUM
    });
    const needQueryData = allowNestedPages;
    const { loading: loading, error: error, data: data } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query ArchiveDialogBaseComponentQuery($contentId:ID!){singleContent(id:$contentId){id archivableDescendantsCount visibleDescendantsCount}}`, {
        variables: {
            contentId: contentId
        },
        skip: !needQueryData
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const countNestedPages = data?.singleContent?.visibleDescendantsCount || 0;
    const isSelectionLimitReached = isOverSelectionLimit || countNestedPages + 1 > (0, $aqBZ0.BULK_ARCHIVE_PAGE_SELECTION_LIMIT);
    const isSpaceAdmin = Boolean(spaceAdminData?.space?.currentUser.isAdmin);
    const fireButtonClickEvent = (0, $42omo.useCallback)((buttonName, isArchive, analyticsSource, attributes)=>{
        (0, $12UWa.fireUIClickEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            actionSubject: 'button',
            actionSubjectId: `${$9893d5f9cd612858$var$buttonSubjectIdPrefix(isArchive)}${buttonName}Button`,
            source: analyticsSource,
            ...attributes && {
                attributes: attributes
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const handleStartArchive = (0, $42omo.useCallback)(()=>{
        // If we are not using automationDiscovery or the user has already seen automation discover,
        // the modal should close after archiving.
        const shouldClose = !shouldUseAutomationDiscovery || !isSpaceAdmin || checkSpaceAdminError || hasUserSeenAutomationDiscoveryMessage;
        if (shouldClose) setIsOpen(false);
        else setIsPageMutationStarted(true);
        const additionalMutationVariables = getAdditionalMutationVariables ? getAdditionalMutationVariables() : null;
        const parentPageId = additionalMutationVariables && additionalMutationVariables.parentPageId || null;
        const additionalEventAttributes = getAdditionalAnalyticsAttributes ? getAdditionalAnalyticsAttributes() : {};
        const eventAttributes = {
            // (note that "includNestedPages" is null as a default, but is equivalent to false)
            includeNestedPages: Boolean(includeNestedPages),
            ...additionalEventAttributes,
            ...!isArchive && {
                parentPageId: parentPageId
            }
        };
        fireButtonClickEvent('Confirm', isArchive, analyticsSource, eventAttributes);
        const mutationVariables = isArchive ? {
            input: [
                {
                    pageID: contentId,
                    ...additionalMutationVariables
                }
            ]
        } : {
            pageIDs: [
                contentId
            ],
            ...additionalMutationVariables
        };
        startMutationCallback(mutationVariables, additionalEventAttributes, // If we are using automationDiscovery and the user has not seen the message,
        // this boolean is used to turn off the flag in the lower left corner.
        shouldUseAutomationDiscovery && isSpaceAdmin && !checkSpaceAdminError && !hasUserSeenAutomationDiscoveryMessage); // Similar to above, this is used to control the automation discovery message in the modal
        if (shouldUseAutomationDiscovery && isSpaceAdmin && !checkSpaceAdminError && !hasUserSeenAutomationDiscoveryMessage) setIsAutomationDiscoveryMessageVisible(true);
    }, [
        contentId,
        analyticsSource,
        fireButtonClickEvent,
        getAdditionalMutationVariables,
        getAdditionalAnalyticsAttributes,
        includeNestedPages,
        isArchive,
        startMutationCallback,
        shouldUseAutomationDiscovery,
        hasUserSeenAutomationDiscoveryMessage,
        isSpaceAdmin,
        checkSpaceAdminError
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        fireButtonClickEvent('Cancel', isArchive, analyticsSource);
        setIsOpen(false);
        experienceTracker.abort({
            name: (0, $jjVGE.getExperienceName)(isArchive),
            reason: 'dialog closed'
        });
    }, [
        analyticsSource,
        fireButtonClickEvent,
        isArchive,
        setIsOpen,
        experienceTracker
    ]);
    const primaryButtonText = (0, $42omo.useMemo)(()=>{
        if (isSelectionLimitReached) return isArchive ? $9893d5f9cd612858$export$a7357cdd1f0b0168.ARCHIVE_archiveParentButtonSelectionLimitReachedText : $9893d5f9cd612858$export$a7357cdd1f0b0168.UNARCHIVE_restoreParentButtonSelectionLimitReachedText;
        if (isArchive) return isSingleArchive ? $9893d5f9cd612858$export$a7357cdd1f0b0168.ARCHIVE_singleArchiveButtonText : $9893d5f9cd612858$export$a7357cdd1f0b0168.ARCHIVE_nestedPagesButtonText;
        else return $9893d5f9cd612858$export$a7357cdd1f0b0168.UNARCHIVE_buttonText;
    }, [
        isArchive,
        isSingleArchive,
        isSelectionLimitReached
    ]);
    const showNextButton = !isNestedActionsDialogNotePageEnabled && !isSingleArchive;
    const Footer = (0, $42omo.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9893d5f9cd612858$export$6f85644dafe908c8, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle",
            onClick: handleClose,
            testId: "button-cancel",
            isDisabled: isPageMutationStarted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9893d5f9cd612858$export$a7357cdd1f0b0168.cancelButtonText)), showNextButton && setIsNestedActionsDialogNotePageEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "primary",
            onClick: ()=>setIsNestedActionsDialogNotePageEnabled(true),
            testId: "button-archive-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9893d5f9cd612858$export$a7357cdd1f0b0168.ARCHIVE_NextButtonText)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
            appearance: isSelectionLimitReached ? 'warning' : 'primary',
            onClick: handleStartArchive,
            testId: "button-archive-primary",
            isDisabled: isPageMutationStarted || isSubmitDisabled,
            isLoading: isPageMutationStarted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), primaryButtonText)))), [
        handleClose,
        isPageMutationStarted,
        showNextButton,
        isSelectionLimitReached,
        handleStartArchive,
        isSubmitDisabled,
        primaryButtonText,
        setIsNestedActionsDialogNotePageEnabled
    ]);
    const headingText = (0, $42omo.useMemo)(()=>{
        const ARCHIVE_nestedPagesTitle = $9893d5f9cd612858$export$a7357cdd1f0b0168.ARCHIVE_nestedPagesTitleGeneric;
        if (!isArchive) // Reminder that for unarchiving (restoring) this component is the 2nd dialog page where the
        // user selects the destination.  We create a similar looking 1st dialog page in
        // UnarchivePageLoader to show the same nested pages info/selection.
        return $9893d5f9cd612858$export$a7357cdd1f0b0168.UNARCHIVE_pageDialogTitle;
        else {
            if (error) return ARCHIVE_nestedPagesTitle;
            if (isSingleArchive) return $9893d5f9cd612858$export$a7357cdd1f0b0168.ARCHIVE_singlePageWithNoteV2;
            else {
                // archiving with nested pages
                const archivableDescendantsCount = data?.singleContent?.archivableDescendantsCount;
                if (isSelectionLimitReached) return $9893d5f9cd612858$export$a7357cdd1f0b0168.ARCHIVE_nestedPagesTitleGeneric;
                else if (archivableDescendantsCount === 0 || !allowNestedPages) // No archive perms for children or standard version of archive
                return $9893d5f9cd612858$export$a7357cdd1f0b0168.ARCHIVE_withoutNestedPagesTitle;
                else return ARCHIVE_nestedPagesTitle;
            }
        }
    }, [
        data,
        isArchive,
        isSingleArchive,
        error,
        allowNestedPages,
        isSelectionLimitReached
    ]);
    if (loading && needQueryData) return null;
    const titleAppearance = appearance !== 'primary' ? appearance : undefined;
    const title = loading && isArchive ? '' : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), headingText);
    const body = descriptionText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), descriptionText) : null;
    const showAutomationDiscoveryMessage = isAutomationDiscoveryMessageVisible && shouldUseAutomationDiscovery && !checkSpaceAdminError && isSpaceAdmin && !archivingError && !isPageMutationStarted;
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        autoFocus: false,
        onClose: handleClose,
        shouldCloseOnEscapePress: true,
        width: `${width}px`,
        shouldScrollInViewport: true,
        messageType: "transactional",
        messageId: "archive-pages-archive-dialog-base-component"
    }, showAutomationDiscoveryMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fTMXN.LazyArchivePageAutomationDiscovery), {
        spaceKey: spaceKey,
        closeModal: ()=>setIsOpen(false)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: (0, $6mKj3.expValEquals)('cc_admin_axp_refactor_modals', 'isEnabled', true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), {
        appearance: titleAppearance
    }, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $61vzn.ReverseTrialLozengeExperiment), {
        touchpointId: "confluence_archive_dialog_header",
        edition: (0, $euL71.ConfluenceEdition).STANDARD
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, body, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, Footer()))), error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, checkSpaceAdminError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: checkSpaceAdminError
    }) : null) : null;
};
module.exports["DialogActionsContainer"] = $9893d5f9cd612858$export$6f85644dafe908c8;
module.exports["ArchiveDialogBaseComponent"] = $9893d5f9cd612858$export$e020ae5d4bb1aae5;

});

parcelRegister("6eoCy", function(module, exports) {

var $1KmJq = parcelRequire("1KmJq");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1kHsc = parcelRequire("1kHsc");


var $jlIaF = parcelRequire("jlIaF");

var $1NBp8 = parcelRequire("1NBp8");


var $12UWa = parcelRequire("12UWa");


var $jjVGE = parcelRequire("jjVGE");


var $3hGsa = parcelRequire("3hGsa");

const $9da6e1d8a9049fca$var$MAX_TRIES = 3;
function $9da6e1d8a9049fca$export$c50a33321d58f613({ contentId: contentId, analyticsSource: analyticsSource, isArchive: isArchive, isBulk: isBulk = false, mutation: mutation, onSuccess: onSuccess, source: source, spaceAlias: spaceAlias, spaceId: spaceId, TriggerComponent: TriggerComponent, onSuccessLinkClick: onSuccessLinkClick, pageCount: pageCount, webuiLink: webuiLink, featureName: featureName }) {
    const [shouldShowProgress, setShouldShowProgress] = (0, $42omo.useState)(false);
    const [shouldUseAutomationDiscovery, setShouldUseAutomationDiscovery] = (0, $42omo.useState)(false);
    const [isArchiveInProgress, setIsArchiveInProgress] = (0, $42omo.useState)(false);
    const [longTaskId, setLongTaskId] = (0, $42omo.useState)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // additionalTrackEventAttributes can be a ref because we just need to pass it on, we don't need
    // to re-render if it changes
    const additionalTrackEventAttributesRef = (0, $42omo.useRef)(undefined);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [mutationError, setMutationError] = (0, $42omo.useState)(undefined);
    // MutationDataBase and TMutationVariables constitute casts from any. Their usage here adds type safety for
    // mutateStartPageArchival, but not for mutation. MutationDataBase is a static type defined in this file.
    // TMutationVariables is a generic type defined by the consumer of this component.
    // TODO: Improve type safety by refactoring code or by upgrading apollo to a version supporting TypedDocumentNode.
    const [mutateStartPageArchival] = (0, $1KmJq.useMutation)(mutation);
    const fireStartArchivalEvent = (0, $42omo.useCallback)((trackEventAttributes)=>{
        const actionName = (0, $12UWa.getActionName)(isArchive, isBulk);
        (0, $12UWa.fireTrackEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            action: `${actionName}Started`,
            actionSubject: 'page',
            actionSubjectId: isBulk ? 'multiple' : contentId,
            source: source,
            attributes: {
                featureName: featureName,
                ...trackEventAttributes
            }
        });
        if (actionName === 'bulkArchive') createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'started',
                actionSubject: actionName,
                source: featureName,
                attributes: {
                    pageCount: pageCount
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        isArchive,
        isBulk,
        source,
        featureName,
        pageCount
    ]);
    const tryArchiveMutation = (0, $42omo.useCallback)((variables, waitTimeBeforeRetry = 3000, attemptNumber = 0)=>{
        attemptNumber++;
        mutateStartPageArchival({
            variables: variables
        }).then((res)=>{
            const data = res?.data;
            const nextLongTaskId = data?.bulkArchivePages?.taskId || data?.bulkUnarchivePages?.taskId || data?.archivePages?.taskId || undefined;
            setLongTaskId(nextLongTaskId);
        }).catch((error)=>{
            // if mutation fails (e.g. there is another archival operation
            // running in the BE), retry two times before throwing an error
            // It retries after 3 seconds, if it sees an exception again,
            // try another time after 5 seconds
            // TODO: need to cover the case for 'page is already archived'
            // In that case we don't need to retry
            if (attemptNumber >= $9da6e1d8a9049fca$var$MAX_TRIES) {
                setMutationError(error);
                if (isArchive && isBulk) createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'failed',
                        actionSubject: 'bulkArchive',
                        source: featureName,
                        attributes: {
                            attemptNumber: attemptNumber,
                            pageCount: pageCount,
                            errorMessage: error.message
                        }
                    }
                }).fire();
                experienceTracker.stopOnError({
                    name: (0, $jjVGE.getExperienceName)(isArchive),
                    error: error,
                    attributes: {
                        featureName: featureName
                    }
                });
            } else setTimeout(()=>{
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: `retry${isArchive ? 'Archive' : 'Restore'}Mutation`,
                        actionSubject: 'page',
                        actionSubjectId: isBulk ? 'multiple' : contentId,
                        source: analyticsSource,
                        attributes: {
                            attemptNumber: attemptNumber,
                            pageCount: pageCount
                        }
                    }
                }).fire();
                tryArchiveMutation(variables, attemptNumber === 1 ? 3000 : 5000, attemptNumber);
            }, waitTimeBeforeRetry);
        });
    }, [
        analyticsSource,
        contentId,
        createAnalyticsEvent,
        experienceTracker,
        featureName,
        isArchive,
        isBulk,
        mutateStartPageArchival,
        pageCount
    ]);
    const startMutation = (0, $42omo.useCallback)((variables, trackEventAttributes, shouldUseAutomationDiscovery = false)=>{
        if (!shouldShowProgress) {
            setShouldShowProgress(true);
            setShouldUseAutomationDiscovery(shouldUseAutomationDiscovery);
            setIsArchiveInProgress(true);
            additionalTrackEventAttributesRef.current = trackEventAttributes;
            fireStartArchivalEvent(trackEventAttributes);
            tryArchiveMutation(variables);
        }
    }, [
        additionalTrackEventAttributesRef,
        fireStartArchivalEvent,
        shouldShowProgress,
        tryArchiveMutation
    ]);
    const getSuccessLink = ()=>{
        if (isArchive) return (0, $1NBp8.SPACE_ARCHIVED_PAGES).toUrl({
            spaceKey: spaceAlias
        });
        else // Restore
        return webuiLink ? `${0, $jlIaF.CONTEXT_PATH}${webuiLink}` : `${0, $jlIaF.CONTEXT_PATH}`;
    };
    const handleSuccess = ()=>{
        setIsArchiveInProgress(false);
        if (onSuccess) onSuccess();
    };
    // Get the appropriate message strings for the archive action
    const flagI18n = (0, $42omo.useMemo)(()=>(0, $3hGsa.getArchiveFlagI18nWithErrorMsgs)({
            isArchive: isArchive
        }), [
        isArchive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, shouldShowProgress ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jjVGE.ArchiveProgressReport), {
        flagI18n: flagI18n,
        longTaskId: longTaskId,
        onSuccess: handleSuccess,
        isArchive: isArchive,
        successLinkHref: getSuccessLink(),
        contentId: contentId,
        source: source,
        error: mutationError,
        isBulk: isBulk,
        onSuccessLinkClick: onSuccessLinkClick,
        pageCount: pageCount,
        spaceId: spaceId,
        additionalTrackEventAttributes: additionalTrackEventAttributesRef.current,
        shouldUseAutomationDiscovery: shouldUseAutomationDiscovery,
        featureName: featureName
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TriggerComponent, {
        archivingError: mutationError,
        isArchiveInProgress: isArchiveInProgress,
        analyticsSource: analyticsSource,
        isArchive: isArchive,
        source: source,
        spaceAlias: spaceAlias,
        startMutationCallback: startMutation
    }));
}
module.exports["ArchiveProcessContainer"] = $9da6e1d8a9049fca$export$c50a33321d58f613;

});


//# sourceMappingURL=UnarchivePagesLoader.1666e8c7.js.map
